import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { onClickFilterSave, onClickFilterClear } from "../../redux/actions";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import FilterButtonForTableHeader from "../FilterButtonForTableHeader/FilterButtonForTableHeader";
import GoalTypeFilter from "./GoalTypeFilter";
import GoalFilter from "./GoalFilter";
import HorizonFilter from "./HorizonFilter";
import RiskToleranceFilter from "./RiskToleranceFilter";
import StatusFilter from "./StatusFilter";
import TypeFilter from "./TypeFilter";
import RIAFilter from "./RIAFilter";
import AdvisorFilter from "./AdvisorFilter";
import DateRangeFilter from "./DateRangeFilter";
import StrategyFilter from "./StrategyFilter";
import FilterPopUp from "../FilterPopUp/FilterPopUp";

const BodyWrapper = styled.div`
  max-height: 60vh;
  min-height: 60vh;
  overflow-y: scroll;
  width: 100%;

  &::-webkit-scrollbar {
    width: 10px;
    border: none;
  }

  .table {
    border-collapse: separate;
    border-spacing: 0 1em;
    width: 100%;

    .tableHeader th {
      text-align: left;
      font-size: 12px;
      color: #004576;
      padding-left: 15px;
      cursor: pointer;
      position: sticky;
      top: 0;
      background-color: white;
    }

    .tableRow {
      font-size: 16px;
      padding-top: 17px;

      .clientName {
        color: #008ef2;
        cursor: pointer;
      }
    }

    .tableRow td:not(:last-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.15);
      padding-left: 15px;
    }

    .tableRow td {
      padding-left: 15px;
    }
  }
`;

const IncomingClientListTable = ({
  listOfAdvisors,
  handleScrollOnTable,
  sortIncomingClientTable,
  handleClientNameClick,
  handleAdvisorNameClick,
  filterApplied,
}) => {
  const { filterDataOnIncomingClientTable } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();

  const [clientNameSortingStatus, setClientNameSortingStatus] = useState(0);
  const [dateOpenSortingStatus, setDateOpenSortingStatus] = useState(1);
  const [typeSortingStatus, setTypeSortingStatus] = useState(0);
  const [goalTypeSortingStatus, setGoalTypeSortingStatus] = useState(0);
  const [goalSortingStatus, setGoalSortingStatus] = useState(0);
  const [horizonSortingStatus, setHorizonSortingStatus] = useState(0);
  const [advisorSortingStatus, setAdvisorSortingStatus] = useState(0);
  const [riskToleranceSortingStatus, setRiskToleranceSortingStatus] =
    useState(0);
  const [strategySortingStatus, setStrategySortingStatus] = useState(0);
  const [statusSortingStatus, setStatusSortingStatus] = useState(0);
  const [currentFilterUi, setCurrentFilterUi] = useState(<></>);
  const [filterPopupLeft, setFilterPopupLeft] = useState(0);
  const [filterPopupTop, setFilterPopupTop] = useState(0);
  const [isFilterPopupVisible, setIsFilterPopupVisible] = useState(false);
  const [filterPopupHeaderName, setFilterPopupHeaderName] = useState("");

  const goalTypeColumnHeader = useRef(null);
  const goalColumnHeader = useRef(null);
  const horizonColumnHeader = useRef(null);
  const riskToleranceColumnHeader = useRef(null);
  const strategyColumnHeader = useRef(null);
  const statusColumnHeader = useRef(null);
  const typeColumnHeader = useRef(null);
  const riaColumnHeader = useRef(null);
  const advisorColumnHeader = useRef(null);
  const dateRangeColumnHeader = useRef(null);

  const handleTableHeaderClick = (tableHeaderName) => {
    if (tableHeaderName === "dateCreated") {
      setDateOpenSortingStatus(
        dateOpenSortingStatus == 2 ? 0 : dateOpenSortingStatus + 1
      );
      sortIncomingClientTable(
        "DateCreated",
        dateOpenSortingStatus == 2 ? 0 : dateOpenSortingStatus + 1
      );
    } else if (tableHeaderName === "clientName") {
      setClientNameSortingStatus(
        clientNameSortingStatus == 2 ? 0 : clientNameSortingStatus + 1
      );
      sortIncomingClientTable(
        "ClientName",
        clientNameSortingStatus == 2 ? 0 : clientNameSortingStatus + 1
      );
    } else if (tableHeaderName === "goalType") {
      setGoalTypeSortingStatus(
        goalTypeSortingStatus == 2 ? 0 : goalTypeSortingStatus + 1
      );
      sortIncomingClientTable(
        "GoalType",
        goalTypeSortingStatus == 2 ? 0 : goalTypeSortingStatus + 1
      );
    } else if (tableHeaderName === "goal") {
      setGoalSortingStatus(goalSortingStatus == 2 ? 0 : goalSortingStatus + 1);
      sortIncomingClientTable(
        "Goal",
        goalSortingStatus == 2 ? 0 : goalSortingStatus + 1
      );
    } else if (tableHeaderName === "horizon") {
      setHorizonSortingStatus(
        horizonSortingStatus == 2 ? 0 : horizonSortingStatus + 1
      );
      sortIncomingClientTable(
        "Horizon",
        horizonSortingStatus == 2 ? 0 : horizonSortingStatus + 1
      );
    } else if (tableHeaderName === "riskTolerance") {
      setRiskToleranceSortingStatus(
        riskToleranceSortingStatus == 2 ? 0 : riskToleranceSortingStatus + 1
      );
      sortIncomingClientTable(
        "RiskTolerance",
        riskToleranceSortingStatus == 2 ? 0 : riskToleranceSortingStatus + 1
      );
    } else if (tableHeaderName === "strategy") {
      setStrategySortingStatus(
        strategySortingStatus == 2 ? 0 : strategySortingStatus + 1
      );
      sortIncomingClientTable(
        "Strategy",
        strategySortingStatus == 2 ? 0 : strategySortingStatus + 1
      );
    } else if (tableHeaderName === "advisor") {
      setAdvisorSortingStatus(
        advisorSortingStatus == 2 ? 0 : advisorSortingStatus + 1
      );
      sortIncomingClientTable(
        "Advisor",
        advisorSortingStatus == 2 ? 0 : advisorSortingStatus + 1
      );
    } else if (tableHeaderName === "type") {
      setTypeSortingStatus(typeSortingStatus == 2 ? 0 : typeSortingStatus + 1);
      sortIncomingClientTable(
        "Type",
        typeSortingStatus == 2 ? 0 : typeSortingStatus + 1
      );
    } else if (tableHeaderName === "status") {
      setStatusSortingStatus(
        statusSortingStatus == 2 ? 0 : statusSortingStatus + 1
      );
      sortIncomingClientTable(
        "Status",
        statusSortingStatus == 2 ? 0 : statusSortingStatus + 1
      );
    }
  };

  const handleFilterPopupCrossButtonClick = () => {
    setIsFilterPopupVisible(false);
  };

  const handleFilterPopupClearClick = () => {
    dispatch(onClickFilterClear(filterPopupHeaderName));
  };

  const handleFilterPopupSaveClick = () => {
    dispatch(onClickFilterSave(filterPopupHeaderName));
    filterApplied();
  };

  useEffect(() => {
    setIsFilterPopupVisible(false);
  }, [filterDataOnIncomingClientTable]);

  const handleFilterClick = (headerName) => {
    setIsFilterPopupVisible(true);
    if (headerName === "Date Created") {
      setCurrentFilterUi(<DateRangeFilter />);
      setFilterPopupLeft(dateRangeColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        dateRangeColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Date Created");
    } else if (headerName === "GoalType") {
      setCurrentFilterUi(<GoalTypeFilter />);
      setFilterPopupLeft(goalTypeColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        goalTypeColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Goal Type");
    } else if (headerName === "Goal") {
      setCurrentFilterUi(<GoalFilter />);
      setFilterPopupLeft(goalColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        goalColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Goal");
    } else if (headerName === "Horizon") {
      setCurrentFilterUi(<HorizonFilter />);
      setFilterPopupLeft(horizonColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        horizonColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Horizon");
    } else if (headerName === "Risk Tolerance") {
      setCurrentFilterUi(<RiskToleranceFilter />);
      setFilterPopupLeft(riskToleranceColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        riskToleranceColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Risk Tolerance");
    } else if (headerName === "Status") {
      setCurrentFilterUi(<StatusFilter />);
      setFilterPopupLeft(statusColumnHeader.current.offsetLeft - 120);
      setFilterPopupTop(
        statusColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Status");
    } else if (headerName === "Type") {
      setCurrentFilterUi(<TypeFilter />);
      setFilterPopupLeft(typeColumnHeader.current.offsetLeft);
      setFilterPopupTop(
        typeColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Type");
    } else if (headerName === "RIA") {
      setCurrentFilterUi(<RIAFilter />);
      setFilterPopupLeft(riaColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        riaColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("RIA");
    } else if (headerName === "Advisor") {
      setCurrentFilterUi(<AdvisorFilter />);
      setFilterPopupLeft(advisorColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        advisorColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Advisor");
    } else if (headerName === "Strategy") {
      setCurrentFilterUi(<StrategyFilter />);
      setFilterPopupLeft(strategyColumnHeader.current.offsetLeft + 100);
      setFilterPopupTop(
        strategyColumnHeader.current.getBoundingClientRect().top + 30
      );
      setFilterPopupHeaderName("Strategy");
    }
  };

  const isColumnFiltered = (column) => {
    return filterDataOnIncomingClientTable.find(
      (data) => data.columnName === column
    );
  };

  return (
    <BodyWrapper onScroll={handleScrollOnTable}>
      {isFilterPopupVisible && (
        <FilterPopUp
          filterField={filterPopupHeaderName}
          left={filterPopupLeft}
          top={filterPopupTop}
          crossButtonClick={handleFilterPopupCrossButtonClick}
          clearClick={handleFilterPopupClearClick}
          saveClick={handleFilterPopupSaveClick}
        >
          {currentFilterUi}
        </FilterPopUp>
      )}
      <table className="table">
        <tr className="tableHeader">
          <th ref={dateRangeColumnHeader}>
            <span onClick={() => handleTableHeaderClick("dateCreated")}>
              Date Created
            </span>
            <FilterButtonForTableHeader
              isColumnFiltered={isColumnFiltered("DateCreated")}
              handleOnClick={() => handleFilterClick("Date Created")}
            />
            <div style={{ paddingLeft: "25px" }}>
              {dateOpenSortingStatus == 1 ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : dateOpenSortingStatus == 2 ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <span>&nbsp;</span>
              )}
            </div>
          </th>
          <th onClick={() => handleTableHeaderClick("clientName")}>
            Client Name
            <div style={{ paddingLeft: "26px" }}>
              {clientNameSortingStatus == 1 ? (
                <FontAwesomeIcon icon={faChevronDown} />
              ) : clientNameSortingStatus == 2 ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <span>&nbsp;</span>
              )}
            </div>
          </th>
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].goalType !== undefined)) && (
            <th ref={goalTypeColumnHeader}>
              <span onClick={() => handleTableHeaderClick("goalType")}>
                Goal Type
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("GoalType")}
                handleOnClick={() => handleFilterClick("GoalType")}
              />
              <div style={{ paddingLeft: "20px" }}>
                {goalTypeSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : goalTypeSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].goal !== undefined)) && (
            <th ref={goalColumnHeader}>
              <span onClick={() => handleTableHeaderClick("goal")}>Goal</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Goal")}
                handleOnClick={() => handleFilterClick("Goal")}
              />
              <div style={{ paddingLeft: "7px" }}>
                {goalSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : goalSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].horizon !== undefined)) && (
            <th ref={horizonColumnHeader}>
              <span onClick={() => handleTableHeaderClick("horizon")}>
                Horizon
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Horizon")}
                handleOnClick={() => handleFilterClick("Horizon")}
              />
              <div style={{ paddingLeft: "15px" }}>
                {horizonSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : horizonSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].riskTolerance !== undefined)) && (
            <th ref={riskToleranceColumnHeader}>
              <span onClick={() => handleTableHeaderClick("riskTolerance")}>
                Risk Tolerance
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("RiskTolerance")}
                handleOnClick={() => handleFilterClick("Risk Tolerance")}
              />
              <div style={{ paddingLeft: "33px" }}>
                {riskToleranceSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : riskToleranceSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].strategy !== undefined)) && (
            <th ref={strategyColumnHeader}>
              <span onClick={() => handleTableHeaderClick("strategy")}>
                Strategy
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Strategy")}
                handleOnClick={() => handleFilterClick("Strategy")}
              />
              <div style={{ paddingLeft: "16px" }}>
                {strategySortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : strategySortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].ria !== undefined)) && (
            <th ref={riaColumnHeader}>
              <span onClick={() => handleTableHeaderClick("type")}>RIA</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("RIA")}
                handleOnClick={() => handleFilterClick("RIA")}
              />
              <div style={{ paddingLeft: "4px" }}>
                {typeSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : typeSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].advisor !== undefined)) && (
            <th ref={advisorColumnHeader}>
              <span onClick={() => handleTableHeaderClick("advisor")}>
                Advisor
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Advisor")}
                handleOnClick={() => handleFilterClick("Advisor")}
              />
              <div style={{ paddingLeft: "14px" }}>
                {advisorSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : advisorSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].type !== undefined)) && (
            <th ref={typeColumnHeader}>
              <span onClick={() => handleTableHeaderClick("type")}>Type</span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Type")}
                handleOnClick={() => handleFilterClick("Type")}
              />
              <div style={{ paddingLeft: "8px" }}>
                {typeSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : typeSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
          {(listOfAdvisors.length == 0 ||
            (listOfAdvisors &&
              listOfAdvisors?.length > 0 &&
              listOfAdvisors[0].status !== undefined)) && (
            <th ref={statusColumnHeader}>
              <span onClick={() => handleTableHeaderClick("status")}>
                Status
              </span>
              <FilterButtonForTableHeader
                isColumnFiltered={isColumnFiltered("Status")}
                handleOnClick={() => handleFilterClick("Status")}
              />
              <div style={{ paddingLeft: "11px" }}>
                {statusSortingStatus == 1 ? (
                  <FontAwesomeIcon icon={faChevronDown} />
                ) : statusSortingStatus == 2 ? (
                  <FontAwesomeIcon icon={faChevronUp} />
                ) : (
                  <span>&nbsp;</span>
                )}
              </div>
            </th>
          )}
        </tr>
        {listOfAdvisors &&
          listOfAdvisors?.length > 0 &&
          listOfAdvisors?.map((data) => (
            <tr className="tableRow">
              <td>{data?.dateCreated}</td>
              <td
                className="clientName"
                onClick={() => {
                  handleClientNameClick(data.goalId);
                }}
              >
                {data?.clientName}
              </td>
              {data?.goalType !== undefined && <td>{data?.goalType}</td>}
              {data?.goal !== undefined && <td>{data?.goal}</td>}
              {data?.horizon !== undefined && <td>{data?.horizon}</td>}
              {data?.riskTolerance !== undefined && (
                <td>{data?.riskTolerance}</td>
              )}
              {data?.strategy !== undefined && <td>{data?.strategy}</td>}
              {data?.ria !== undefined && <td>{data?.ria}</td>}
              {data?.advisor !== undefined && (
                <td
                  className="clientName"
                  onClick={() => handleAdvisorNameClick(data.advisorId)}
                >
                  {data?.advisor}
                </td>
              )}
              {data?.type !== undefined && <td>{data?.type}</td>}
              {data?.status !== undefined && <td>{data?.status}</td>}
            </tr>
          ))}
      </table>
    </BodyWrapper>
  );
};

export default IncomingClientListTable;
